import {gql} from '@apollo/client';

export const FRAGMENT_CONTEST_CLIENT_ITEM = gql`
  fragment ContestClientItem on ContestClientType {
    id
    contestId
    startedAt
    answersCount
    duration
    answers
    rightAnswers
    isFinished
    isWinner
    client {
      id
      user {
        id
        fullname
        avatar {
          id
          path
        }
      }
    }
  }
`;

export const FRAGMENT_CONTEST_BASE = gql`
  fragment ContestBase on ContestType {
    id
    name
    startTime
    endTime
    duration
    content
    itemsCount
    isPublished
    cover {
      id
      path
    }
    contestClients {
      ...ContestClientItem
    }
  }
  ${FRAGMENT_CONTEST_CLIENT_ITEM}
`;



export const QUERY_CONTEST_LIST = gql`
  query ContestList {
    contestList {
      ...ContestBase
    }
  }
  ${FRAGMENT_CONTEST_BASE}
`;

export const QUERY_CONTEST_CLIENT_LIST = gql`
  query ContestClientList {
    contestClientList {
      ...ContestClientItem
    }
  }
  ${FRAGMENT_CONTEST_CLIENT_ITEM}
`;

export const QUERY_CONTEST_DETAIL = gql`
  query ContestDetail($id: ID!) {
    contestDetail(id: $id) {
      ...ContestBase
    }
  }
  ${FRAGMENT_CONTEST_BASE}
`;

export const MUTATION_CONTEST_CLIENT_SAVE = gql`
  mutation ContestClientSave($input: ContestClientSaveInput!) {
    contestClientSave(input: $input) {
      obj {
        ...ContestClientItem
      }
      errors {
        field
        messages
      }
    }
  }
  ${FRAGMENT_CONTEST_CLIENT_ITEM}
`

export const QUERT_CONTEST_ITEM_LIST = gql`
  query ContestItemList($contestId: ID) {
    contestItemList(contest: $contestId) {
      id
      question
      variants
    }
  }
`;
